// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/stylesheets/dialogs/openAnnotatedImage.styl
// module id = 129
// module chunks = 0